const state = {
    pp_magasinSelectionne: '',
    pp_donneesCa: null,
    pp_donneesJournaliere: null,
    pp_donneesHistorique: null,
    pp_donneesRupture: null,
    pp_donneesAbc: null,
    pp_isRefreshing: false
};

const getters = {
    pp_getMagasin: state => state.pp_magasinSelectionne,
    pp_getCa: state => state.pp_donneesCa,
    pp_getJournaliere: state => state.pp_donneesJournaliere,
    pp_getHistorique: state => state.pp_donneesHistorique,
    pp_getRupture: state => state.pp_donneesRupture,
    pp_getAbc: state => state.pp_donneesAbc,
    pp_getIsRefreshing: state => state.pp_isRefreshing,
};

const mutations = {
    pp_setMagasin(state, magasinId) {
        state.pp_magasinSelectionne = magasinId;
    },
    pp_setCa(state, data) {
        state.pp_donneesCa = data;
    },
    pp_setJournaliere(state, data) {
        state.pp_donneesJournaliere = data;
    },
    pp_setHistorique(state, data) {
        state.pp_donneesHistorique = data;
    },
    pp_setRupture(state, data) {
        state.pp_donneesRupture = data;
    },
    pp_setAbc(state, data) {
        state.pp_donneesAbc = data;
    },
    pp_setRefreshing(state, isRefreshing) {
        state.pp_isRefreshing = isRefreshing;
    },
    // Invalidation de tous les caches du module (au changement de magasin)
    pp_invalidateCaches(state) {
        state.pp_donneesCa = null;
        state.pp_donneesJournaliere = null;
        state.pp_donneesHistorique = null;
        state.pp_donneesRupture = null;
        state.pp_donneesAbc = null;
    }
};

const actions = {
    pp_updateMagasin({ commit }, magasinId) {
        commit('pp_setMagasin', magasinId);
        // Invalide les caches pour forcer le re-fetch des onglets
        commit('pp_invalidateCaches');
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};